<template>
    <div class="pasword-change">
    </div>
</template>


<script>

import axios from "axios";

export default {
    name: 'LostpwSiginin',

    async mounted() {
        this.$store.commit("auth/SET_KEY_PASSWORD", this.$route.params.id);
        await axios.get('/sanctum/csrf-cookie')
        await axios.post("/api/reset-pw", {key : this.$route.params.id }).then(response => {
            if(response.data.status == "ok"){
                this.$toast.success("To continue, please change your password")
                this.$router.push("/change-password")
            }
            else{
                this.$toast.error("This code is not valid")
                this.$router.push("/")
            }
        })
    },
    metaInfo() {
        return {
            title: "Lost Password",
            meta: [
                { name: 'description', content:  'Testing 123'},
                /*{ property: 'og:title', content: "Epiloge - Build your network in your field of interest"},
                */
            ]
        }
    }
}

</script>
